module.exports = __webpack_public_path__ + "img/archway_k_b2.36c89dd8.jpg";